/**
 * Determines wheter a checked number is lower or equal to the limit
 * @note the logic kinda breaks for negative numbers, depends on what you need
 * @param checked number to check
 * @param limit number
 * @returns a boolean; does it fit in?
 */
export function fitsWithin(checked: number, limit: number): boolean {
  return checked <= limit
}

/** Take 1-5 score ("stars") and return something more manageble, a 0-100 range
 *  The trick - the input does not allow for 0-stars
 *
 *  @param score - number of "stars" or whatever
 *  @returns a round, nice score between 0 and 100
 */
export function shift1To5ScoreInto0To100Range(score: number): number {
  if (score < 1 || score > 5) throw 'The initial score is out of expected range!'
  const zeroBased = score - 1 // the input does not allow for 0-stars

  return zeroBased * 25
}
